module.exports = __webpack_public_path__ + "img/A3_tourist_posters.7dd7a960.jpg";